import { v4 as uuidv4 } from 'uuid';

export function generateGuid(): string {
  return uuidv4();
}
